import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useKeycloak } from 'src/contexts/KeycloakContext';
import { IconUser } from '@tabler/icons-react';
import { getUserProfileKeyCloak } from 'src/utils/getRoleKeycloak';
import { BORDER_RADIUS } from '@com.ctu.iotlab/ui-library';

export default function AccountMenu() {
  const { logout,token } = useKeycloak();
  const navigate = useNavigate()
  const { t } = useTranslation()
  const theme = useTheme()

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout()
    handleClose()
  };

  const userInfo = getUserProfileKeyCloak(token)

  return (
    <React.Fragment>
      <Box onClick={handleClick} sx={{ borderRadius: `${BORDER_RADIUS}px` }} pl={2} gap={1} display='flex' alignItems="center" justifyContent='space-between'>
        <Typography variant='subtitle2'>  {userInfo?.fullName}</Typography>
        <Tooltip title="Tài khoản">
          <Avatar
            variant='rounded'
            sx={{
              border: '1px solid',
              cursor: "pointer",
              borderRadius: "50%",
              borderColor: theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.primary.main,
              background: theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.primary.main,
              color: theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.text.secondary,
              '&[aria-controls="menu-list-grow"],&:hover': {
                borderColor: theme.palette.primary.main,
                background: theme.palette.primary.main,
                color: theme.palette.primary.light
              }
            }}
            color="inherit">
            <IconUser />
          </Avatar>
        </Tooltip>
      </Box>
      <></>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem>
          <ListItemIcon>
            <IconUser />
          </ListItemIcon>
          {userInfo?.fullName}
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => navigate("/profile")} sx={{ fontWeight: 400 }}>
          {t("Thông tin cá nhân")}
        </MenuItem>
        <MenuItem onClick={() => handleLogout()} sx={{ fontWeight: 400 }}>{t("Đăng xuất")} </MenuItem>
      </Menu>
    </React.Fragment>
  );
}
